/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProcessingState = 'TransportationScheduling' | 'TransportationSchedulingDone' | 'Approved' | 'ProcessingByWarehouse' | 'FixedByWarehouse' | 'Rolling' | 'WaitingToUnload' | 'Unloading' | 'Completed';

export const ProcessingState = {
    TransportationScheduling: 'TransportationScheduling' as ProcessingState,
    TransportationSchedulingDone: 'TransportationSchedulingDone' as ProcessingState,
    Approved: 'Approved' as ProcessingState,
    ProcessingByWarehouse: 'ProcessingByWarehouse' as ProcessingState,
    FixedByWarehouse: 'FixedByWarehouse' as ProcessingState,
    Rolling: 'Rolling' as ProcessingState,
    WaitingToUnload: 'WaitingToUnload' as ProcessingState,
    Unloading: 'Unloading' as ProcessingState,
    Completed: 'Completed' as ProcessingState
};

